import { siteversion } from '@envs/version';

const envLocal = {
  version: siteversion.version,
  kcUrl: 'https://cloudia2-staging.tcpdev.com/auth/',
  kcRealm: {
    cloudia: 'cloudia-test',
  },
  kcClientID: 'cloudia-frontend',
  apiUrl: 'https://cloudia2-test.tcpdev.com/api/',
  production: false,
  localBackend: true,
  cvExporterUrl:
    'https://script.google.com/a/macros/symfoni.com/s/AKfycbzlxaafncf5nuG58NbYCaecrWibAh8hJkgbVLJMtJTr/dev',
  env: 'TEST',
  cloudiaCustomerUrl: origin,
  cloudia1Url: 'https://cloudia-staging.thecloudpeople.com',
  cloudia1ApiUrl:
    'https://europe-west1-cloudia-staging-environment.cloudfunctions.net/api/',
  peerjs: {
    url: {
      cloudia: 'cloudia2-staging.tcpdev.com',
    },
  },
  tenant: 'cloudia',
  useGoogleAnalytics: false,
  analyticsTrackingId: '',
  useHotJar: false,
  hotjarId: null,
};

const envTest = {
  version: siteversion.version,
  kcUrl: 'https://cloudia2-staging.tcpdev.com/auth/',
  kcRealm: {
    cloudia: 'cloudia-test',
  },
  kcClientID: 'cloudia-frontend',
  apiUrl: 'https://cloudia2-test.tcpdev.com/api/',
  production: false,
  localBackend: false,
  cvExporterUrl:
    'https://script.google.com/a/macros/symfoni.com/s/AKfycbzlxaafncf5nuG58NbYCaecrWibAh8hJkgbVLJMtJTr/dev',
  env: 'TEST',
  cloudiaCustomerUrl: 'https://cloudia2-customer-test.tcpdev.com',
  cloudia1Url: 'https://cloudia-staging.thecloudpeople.com',
  cloudia1ApiUrl:
    'https://europe-west1-cloudia-staging-environment.cloudfunctions.net/api/',
  peerjs: {
    url: {
      cloudia: 'cloudia2-staging.tcpdev.com',
    },
  },
  tenant: 'cloudia',
  useGoogleAnalytics: true,
  analyticsTrackingId: 'GTM-WX6Z3PN5',
  useHotJar: true,
  hotjarId: 3600819,
};

const envStaging = {
  version: siteversion.version,
  kcUrl: 'https://cloudia2-staging.tcpdev.com/auth/',
  kcRealm: {
    cloudia: 'cloudia-staging',
  },
  kcClientID: 'cloudia-frontend',
  apiUrl: 'https://cloudia2-staging.tcpdev.com/api/',
  production: false,
  localBackend: false,
  cvExporterUrl:
    'https://script.google.com/a/macros/symfoni.com/s/AKfycbz-mVqDQnFuDDHXzy6fmKzyetgjR54rq-vWfSU1iqS6qi9JyLSoFWxysKjmNWMFOgS5SA/exec',
  env: 'STAGING',
  cloudiaCustomerUrl: 'https://cloudia2-customer-staging.tcpdev.com',
  cloudia1Url: 'https://cloudia-staging.thecloudpeople.com',
  cloudia1ApiUrl:
    'https://europe-west1-cloudia-staging-environment.cloudfunctions.net/api/',
  peerjs: {
    url: {
      asknow: 'cloudia2-staging.tcpdev.com',
    },
  },
  tenant: 'cloudia',
  useGoogleAnalytics: true,
  analyticsTrackingId: 'GTM-T9LCG7MP',
  useHotJar: true,
  hotjarId: 3622607,
};

const envDemo = {
  version: siteversion.version,
  kcUrl: 'https://cloudia2-staging.tcpdev.com/auth/',
  kcRealm: {
    cloudia: 'cloudia-demo',
  },
  kcClientID: 'cloudia-frontend',
  apiUrl: 'https://cloudia2-demo.tcpdev.com/api/',
  production: false,
  localBackend: false,
  cvExporterUrl:
    'https://script.google.com/a/macros/symfoni.com/s/AKfycbz-mVqDQnFuDDHXzy6fmKzyetgjR54rq-vWfSU1iqS6qi9JyLSoFWxysKjmNWMFOgS5SA/exec',
  env: 'DEMO',
  cloudiaCustomerUrl: 'https://cloudia2-customer-demo.tcpdev.com',
  cloudia1Url: 'https://cloudia-staging.thecloudpeople.com',
  cloudia1ApiUrl:
    'https://europe-west1-cloudia-staging-environment.cloudfunctions.net/api/',
  peerjs: {
    url: {
      asknow: 'cloudia2-staging.tcpdev.com',
    },
  },
  tenant: 'cloudia',
  useGoogleAnalytics: false,
  analyticsTrackingId: '',
  useHotJar: false,
  hotjarId: null,
};

const envProd = {
  version: siteversion.version,
  kcUrl: 'https://cloudia.thecloudpeople.com/auth/',
  kcRealm: {
    cloudia: 'cloudia',
  },
  kcClientID: 'cloudia-frontend',
  apiUrl: 'https://cloudia.thecloudpeople.com/api/',
  production: true,
  localBackend: false,
  cvExporterUrl:
    'https://script.google.com/a/macros/symfoni.com/s/AKfycbycnM5PBcZKWg99WAwUk5yrk8BDJwmFSzKsEPokughXbrxPUD4th6pM7QmXgONVgqQ3yw/exec',
  env: 'PROD',
  cloudiaCustomerUrl: 'https://customer.thecloudpeople.com/',
  cloudia1Url: 'https://cloudia.thecloudpeople.com',
  cloudia1ApiUrl: 'https://europe-west1-cloudia-b0075.cloudfunctions.net/api',
  peerjs: {
    url: {
      asknow: 'cloudia2.tcpdev.com',
    },
  },
  tenant: 'cloudia',
  useGoogleAnalytics: true,
  analyticsTrackingId: 'GTM-TXFN6372',
  useHotJar: true,
  hotjarId: 3622603,
};

export const environment = getEnvs();

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
function getEnvs() {
  // eslint-disable-next-line
  let envName = window["env"].env_name;
  if (envName === 'prod') {
    return envProd;
  }
  if (envName === 'staging') {
    return envStaging;
  }
  if (envName === 'local') {
    return envLocal;
  }
  if (envName === 'demo') {
    return envDemo;
  }
  return envTest;
}
